import { render, staticRenderFns } from "./ViewAssignment.vue?vue&type=template&id=6929b52f&scoped=true&"
import script from "./ViewAssignment.vue?vue&type=script&lang=js&"
export * from "./ViewAssignment.vue?vue&type=script&lang=js&"
import style0 from "./ViewAssignment.vue?vue&type=style&index=0&id=6929b52f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6929b52f",
  null
  
)

export default component.exports